import Vue from 'vue'
import Vuex from 'vuex'

import global from './global.js'
import account from './account.js'
import events from './events.js'
import attribution from './attribution.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    global,
    account,
    events,
    attribution
  }
})
